import Analytics from './'
const { facebookPixel, pinterestPixel, redditPixel } = Analytics;

export default function () {
    facebookPixel('trackCustom', 'InterviewCompleted');
    pinterestPixel('track', 'InterviewCompleted');
    redditPixel('track', 'Lead')
}